import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';
import { filterOptions } from '../data/mockData';

const FilterSection = ({ title, children, defaultOpen = true }) => {
  const [isOpen, setIsOpen] = useState(defaultOpen);

  return (
    <div className="border-b border-gray-200 pb-4 mb-4">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="flex items-center justify-between w-full text-left mb-3"
      >
        <h3 className="text-base font-normal text-[#1a365d] tracking-wide">{title}</h3>
        {isOpen ? (
          <ChevronUp className="w-4 h-4 text-gray-500" />
        ) : (
          <ChevronDown className="w-4 h-4 text-gray-500" />
        )}
      </button>
      {isOpen && <div className="space-y-2">{children}</div>}
    </div>
  );
};

const Filters = ({ selectedFilters, onFilterChange }) => {
  const handleFilterClick = (type, value) => {
    onFilterChange(type, value);
  };

  return (
    <aside className="w-full lg:w-56 shrink-0">
      {/* Look Filter */}
      <FilterSection title="Look">
        {filterOptions.look.map((option) => (
          <button
            key={option}
            onClick={() => handleFilterClick('look', option)}
            className={`block w-full text-left py-1 text-sm transition-colors ${
              selectedFilters.look === option
                ? 'text-[#1a365d] font-medium'
                : 'text-gray-600 hover:text-[#1a365d]'
            }`}
          >
            {option}
          </button>
        ))}
      </FilterSection>

      {/* Metal Filter */}
      <FilterSection title="Metal">
        {filterOptions.metal.map((option) => (
          <button
            key={option.name}
            onClick={() => handleFilterClick('metal', option.name)}
            className={`flex items-center gap-3 w-full text-left py-1 text-sm transition-colors ${
              selectedFilters.metal === option.name
                ? 'text-[#1a365d] font-medium'
                : 'text-gray-600 hover:text-[#1a365d]'
            }`}
          >
            <span
              className="w-4 h-4 rounded-full border border-gray-300"
              style={{ backgroundColor: option.color }}
            />
            {option.name}
          </button>
        ))}
      </FilterSection>

      {/* Shape Filter */}
      <FilterSection title="Shape">
        {filterOptions.shape.map((option) => (
          <button
            key={option}
            onClick={() => handleFilterClick('shape', option)}
            className={`block w-full text-left py-1 text-sm transition-colors ${
              selectedFilters.shape === option
                ? 'text-[#1a365d] font-medium'
                : 'text-gray-600 hover:text-[#1a365d]'
            }`}
          >
            {option}
          </button>
        ))}
      </FilterSection>
    </aside>
  );
};

export default Filters;
